import React from "react"

import { PrimaryText } from "@front-shared/elements/primaryText.element"

import { LoginStep } from "../../../../config/auth.config"
import { useAppDispatch } from "../../../../store/appDispatch.hook"
import { useAppSelector } from "../../../../store/selectors/app.selector"
import { authSelector } from "../../../../store/selectors/auth.selector"
import { authSetLoginStep } from "../../../../store/slices/auth.slice"
import { authUpdatePhoneNumber } from "../../../../store/thunks/auth.thunks"
import { PhoneNumberForm } from "../../mfa/phoneNumberForm"

export const PhoneNumberStep: React.FunctionComponent = () => {
    const dispatch = useAppDispatch()

    const authState = useAppSelector(authSelector)

    const onSubmit = (phoneNumber: string) => {
        dispatch(
            authUpdatePhoneNumber({
                payload: {
                    phoneNumber,
                },
                onSuccess: () => {
                    dispatch(
                        authSetLoginStep(LoginStep.MFA_SMS_CODE_COLLECTION),
                    )
                },
            }),
        )
    }

    return (
        <div className="relative">
            <PrimaryText
                className="whitespace-pre-wrap mb-[24px]"
                typography="h3"
            >
                Set up SMS Authentication
            </PrimaryText>

            <PrimaryText
                className="whitespace-pre-wrap mb-[40px]"
                typography="text"
                size={20}
            >
                We'll send a verification code to your phone as part of
                multi-factor authentication (MFA).
            </PrimaryText>

            <PhoneNumberForm
                isCtaLoading={authState.isLoading}
                onSubmit={onSubmit}
            />
        </div>
    )
}
